<template lang="pug">
	modal(v-if="tarea.TareaID", :max-width="900")
		.card.text-left
			.card-header
				span.fa.fa-info.mr-2
				span {{ tarea.Titulo }} - <i>{{ tarea.UsuarioNombre }}</i>
				button.close(@click="cerrar") &times;
			.card-body.bg-light(style="border-bottom: 1px solid #e0e0e0;")
				.row
					.col-xs-6.col-sm-6.col-md-6.col-lg-6.col-xl-6
						h2
							span.fa.fa-edit.mr-2
							span {{ tarea.Titulo }}
						div
							span.text-danger(v-if="tarea.Fotografia === 'Si'" style="font-size:1.5em;margin-right: 20px;")
								span.fa.fa-camera.mr-2
								span Fotografía
							span.text-danger(v-if="tarea.Fotografia === 'Si'" style="font-size:1.5em;margin-right: 20px;")
								span.fa.fa-video-camera.mr-2
								span Vídeo
					.col-xs-6.col-sm-6.col-md-6.col-lg-6.col-xl-6.text-right
						div(style="display:flex;flex-direction: row-reverse")
							avatar(:usuario="tarea.UsuarioID", :width="60")
							div
								span
									b {{tarea.UsuarioNombre}}
								br
								span(style="font-size:0.9em;") {{ tarea.FechaCreacion | moment('DD-MM-YYYY') }} a las {{ tarea.FechaCreacion | moment('HH:mm:ss')}}
								br
								span(style="font-size:0.9em;opacity:0.7")
									i (Creado por {{ tarea.UsuarioCreadorNombre }})

			.card-body(style="border-bottom: 1px solid #e0e0e0;")
				.row
					.col-xs-12.col-sm-6.col-md-6.col-lg-6.col-xl-6.mb-6
						h4 ¿Qué se pide?
						hr
						div(v-html="Descripcion")

						h4.mt-4 ¿Cuando hay que hacerlo?
						hr
						span.text-danger(v-if="!tarea.FechaEvento")
							span.fa.fa-ban.mr-2
							span No se ha especificado fecha
						span(v-else)
							span.fa.fa-calendar.mr-2
							span El {{ tarea.FechaEvento | moment('DD-MM-YYYY') }} a las {{ tarea.FechaEvento | moment('HH:mm')}} h.

						h4.mt-4 ¿Para cuando se necesita?
						hr
						span.text-danger(v-if="!tarea.FechaPublicacion")
							span.fa.fa-ban.mr-2
							span No se ha especificado fecha
						span(v-else)
							span.fa.fa-calendar.mr-2
							span El {{ tarea.FechaPublicacion | moment('DD-MM-YYYY') }} a las {{ tarea.FechaPublicacion | moment('HH:mm')}} h.

						h4.mt-4 ¿Dónde va destinado?
						hr
						span.m-3(
							v-for="destino in Destinos"
							:key="destino.DestinoID"
							:class="destino.Icono"
							style="font-size: 2em;"
							:title="destino.Nombre"
						)

					.col-xs-12.col-sm-6.col-md-6.col-lg-6.col-xl-6.mb-6
						h4 ¿Dónde?
						hr
						div(id="mapaEvento", v-show="tarea.LatitudEvento && tarea.LongitudEvento")

			.card-body.bg-light(v-if="tarea.FechaRealizada")
				.row
					.col-xs-12.col-sm-12.col-md-6.col-xl-6.col-lg-6
						h4
							span.fa.fa-check.mr-2
							| Trabajo finalizado por {{ tarea.UsuarioRealizadorNombre }}
							br
							span(style="font-size:0.6em;") El {{ tarea.FechaRealizada | moment('DD-MM-YYYY')}} a las {{ tarea.FechaRealizada | moment('HH:mm')}} h.
						p(v-if="tarea.ComentariosFinales")
							span.fa.fa-quote-left.mr-2
							span {{ tarea.ComentariosFinales }}

					.col-xs-12.col-sm-12.col-md-6.col-xl-6.col-lg-6.text-right
						MiniGaleria(
							:key="tarea.GaleriaID",
							:GaleriaID="tarea.GaleriaID",
							@selecciona="acceder"
						)

			.card-body(v-if="tarea.FechaFinalizada")
				h4
					span.fa.fa-thumbs-up.mr-2
					| Trabajo publicado por {{ tarea.UsuarioNombre }} el {{ tarea.FechaFinalizada | moment('DD-MM-YYYY') }} a las {{ tarea.FechaFinalizada | moment('HH:mm')}}


			.card-footer
				button.m-2.btn.btn-primary(v-if="puedeEditar", @click="editar")
					span.fa.fa-edit.mr-2
					span Editar

				button.m-2.btn.btn-danger(v-if="puedeEditar", @click="eliminar")
					span.fa.fa-trash.mr-2
					span Eliminar

				button.m-2.btn.btn-danger(v-if="puedeRealizar" @click="rechazar = true")
					span.fa.fa-ban.mr-2
					span Rechazar

				button.m-2.btn.btn-warning(v-if="puedeRealizar" @click="realizar = true")
					span.fa.fa-check.mr-2
					span Terminado

				button.m-2.btn.btn-success(v-if="puedePublicar" @click="publicar")
					span.fa.fa-check.mr-2
					span Publicado

		RealizarTarea(
			v-if="realizar"
			:TareaID="TareaID"
			@cerrar="realizar = null"
			@finalizada="cerrar"
		)

		RechazarTarea(
			v-if="rechazar"
			:TareaID="TareaID"
			@rechazada="cerrar"
			@cerrar="rechazar = null"
		)
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import RealizarTarea from './tareaRealizada.component'
import RechazarTarea from './rechazarTarea.component'
import MiniGaleria from '../../../../galerias/vue/componentes/listado-galerias/mini-galeria'
export default {
	props: ['TareaID'],
	components: {
		RealizarTarea,
		RechazarTarea,
		MiniGaleria
	},
	data () {
		return {
			map: null,
			marcador: null,
			realizar: null,
			rechazar: null,
			destinos: [],
			tarea: {
				TareaID: null,
				TareaOriginalID: null,
				Titulo: null,
				Descripcion: null,
				Fotografia: 'No',
				Video: 'No',
				FechaPublicacion: null,
				FechaEvento: null,
				LatitudEvento: null,
				LongitudEvento: null,
				UsuarioAsignado: null,
				UsuarioAsignadoNombre: null,
				UsuarioID: null,
				UsuarioNombre: null,
				UsuarioAvatar: null,
				UsuarioCreador: null,
				UsuarioCreadorNombre: null,
				UsuarioDescarta: null,
				UsuarioDescartaNombre: null,
				FechaModificada: null,
				FechaDescartada: null,
				FechaCreacion: null,
				FechaFinalizada: null,
				FechaRealizada: null,
				GaleriaID: null,
				ComentariosFinales: null
			}
		}
	},
	created () {
		this.getDestinos()
		this.getTarea()
	},
	computed: {
		...mapGetters({
			permisos: 'permisos/permisos',
			usuario: 'session/usuario'
		}),
		puedeEditar () {
			/*
				Puede editar si...
					- No se ha hecho ya el trabajo
					- Es el usuario que creó la tarea
					- Es el usuario de la tarea
					- Tiene permisos para ello
			*/
			if (this.tarea.FechaRealizada) {
				return false
			}

			if (this.tarea.UsuarioID === this.usuario.ID || this.tarea.UsuarioCreador === this.usuario.ID || this.permisos.produccion_audiovisual_editarTodas) {
				return true
			}
			return false
		},
		puedePublicar () {
			/*
				Puede publicar si...
					- Se ha hecho ya el trabajo
					- Es el usuario que creó la tarea
					- Es el usuario de la tarea
					- Tiene permisos para ello
			*/
			if (!this.tarea.FechaRealizada || this.tarea.FechaFinalizada) {
				return false
			}

			if (this.tarea.UsuarioID === this.usuario.ID || this.tarea.UsuarioCreador === this.usuario.ID || this.permisos.produccion_audiovisual_editarTodas) {
				return true
			}
			return false
		},
		puedeRealizar () {
			/*
				Puede editar si...
					- No se ha hecho y a el trabajo
					- Tiene permisos para ello
			*/
			if (this.tarea.FechaRealizada) {
				return false
			}

			if (this.permisos.produccion_audiovisual_realizador) {
				return true
			}
			return false
		},
		Descripcion () {
			if (!this.tarea.Descripcion) {
				return ''
			}

			const desc = this.tarea.Descripcion.split('\n')

			return desc.reduce((acum, linea) => {
				acum = acum + '<p>' + linea + '</p>'
				return acum
			}, '')
		},
		Destinos () {
			if (!this.tarea.TareaID) {
				return []
			}

			return this.destinos.filter(d => this.tarea.Destinos.indexOf(d.DestinoID) >= 0)
		}
	},
	methods: {
		getDestinos () {
			axios.get('produccion-audiovisual/php/api/getDestinos.php')
				.then(res => {
					this.destinos = res.data
				})
				.catch(e => {
					console.error(e)
				})
		},
		getTarea () {
			axios.get('produccion-audiovisual/php/api/getTarea.php?TareaID=' + this.TareaID)
				.then(res => {
					this.tarea = res.data
					window.setTimeout(() => {
						this.muestraMapa()
					}, 300)
				})
				.catch(e => {
					console.error(e)
				})
		},
		muestraMapa () {
			// eslint-disable-next-line
			this.map = new google.maps.Map(document.getElementById('mapaEvento'), {
				center: {lat: this.tarea.LatitudEvento, lng: this.tarea.LongitudEvento},
				zoom: 15
			})

			if (this.marcador) {
				this.marcador.setMap(null)
			}

			// Añadimos el marcador
			// eslint-disable-next-line
			this.marcador = new google.maps.Marker({
				position: {lat: this.tarea.LatitudEvento, lng: this.tarea.LongitudEvento},
				title: this.tarea.Titulo || 'Evento',
				map: this.map
			})
		},
		acceder () {
			this.$router.push('/main/galerias/' + this.tarea.GaleriaID)
		},
		editar () {
			this.$emit('editar', this.TareaID)
			this.cerrar()
		},
		publicar () {
			this.$store.commit('alertas/confirm', {
				titulo: '¿Marcar tarea como publicada?',
				mensaje: `¿Quieres marcar la tarea como publicada?`,
				callback: acepta => {
					if (acepta) {
						axios.post('produccion-audiovisual/php/api/publicar.php', { TareaID: this.TareaID })
							.then(res => {
								this.$store.commit('toast/success', {
									titulo: 'Tarea publicada correctamente'
								})
								this.cerrar()
							})
							.catch(this.$responseError)
					}
				}
			})
		},
		eliminar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar tarea',
				mensaje: `¿Quieres eliminar esta tarea?`,
				callback: acepta => {
					if (acepta) {
						axios.post('produccion-audiovisual/php/api/eliminar.php', {TareaID: this.TareaID})
							.then(res => {
								this.$store.commit('toast/success', {
									titulo: 'Tarea eliminada'
								})
								this.cerrar()
							})
							.catch(this.$responseError)
					}
				}
			})
		},
		cerrar () {
			this.$emit('actualizar')
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>
#mapaEvento {
   height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/modulos/produccion-audiovisual/vue/components/detalles/tareaDetalle.component.vue